import { FC, PropsWithChildren, createContext, useContext } from 'react';

const ExternalContext = createContext(false);
export const ProvideExternalMode: FC<PropsWithChildren<{ external?: boolean }>> = ({ children, external }) => {
  return <ExternalContext.Provider value={typeof external !== 'undefined' ? external : true}>{children}</ExternalContext.Provider>;
};
export const useIsExternalMode = () => useContext(ExternalContext);
